<template>
  <div class="websites-shell">


    <nav class="websites-tabs" aria-label="Websites sections">
      <router-link
        v-for="tab in tabs"
        :key="tab.name"
        :to="tab.to"
        exact
        class="websites-tab"
        active-class="websites-tab--active"
      >
        <span class="websites-tab__label">{{ tab.label }}</span>
      </router-link>
    </nav>

    <main class="websites-body">
      <router-view />
    </main>
  </div>
</template>

<script>
export default {
  name: 'WebsitesLayout',
  data () {
    return {
      tabs: [
        { name: 'Dashboard', label: 'Dashboard', to: '/websites' },
        { name: 'Products',  label: 'Products',  to: '/websites/products' },
        { name: 'Articles',  label: 'Articles',  to: '/websites/articles' },
        { name: 'News',      label: 'News',      to: '/websites/news' },
        { name: 'Divisions', label: 'Divisions', to: '/websites/divisions' },
        { name: 'Doctors',   label: 'Doctors',   to: '/websites/doctors' },
        { name: 'Videos',    label: 'Videos',    to: '/websites/videos' },
        { name: 'Timeline',  label: 'Timeline',  to: '/websites/timeline' },
      ],
    }
  },
}
</script>

<style scoped>
.websites-shell {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 16px 4px 32px;
}

.websites-tabs {
  display: flex;
  gap: 6px;
  padding: 6px;
  background: #ffffff;
  border: 1px solid #e5e9f2;
  border-radius: 999px;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.04);
  overflow-x: auto;
}
.websites-tab {
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 999px;
  font-size: 0.82rem;
  font-weight: 600;
  color: #4b5563;
  text-decoration: none;
  white-space: nowrap;
  transition: background 0.15s ease, color 0.15s ease;
}
.websites-tab:hover { background: #e6f4ef; color: #0e5b46; }
.websites-tab--active {
  background: linear-gradient(135deg, #0e5b46 0%, #16a07a 100%);
  color: #ffffff;
  box-shadow: 0 4px 10px rgba(22, 160, 122, 0.25);
}

.websites-body { display: flex; flex-direction: column; gap: 14px; }
</style>

<style>
/* ---- Shared website CRUD page styles (intentionally unscoped) ---- */
.wsp-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 4px 0;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.wsp-toolbar__title {
  display: flex;
  gap: 12px;
  align-items: stretch;
}
.wsp-toolbar__accent {
  width: 4px;
  border-radius: 4px;
  background: linear-gradient(180deg, #0e5b46 0%, #16a07a 100%);
}
.wsp-toolbar__title h1 {
  margin: 0;
  font-size: 1.15rem;
  color: #1f2a44;
  font-weight: 700;
}
.wsp-toolbar__title p {
  margin: 2px 0 0;
  font-size: 0.78rem;
  color: #6b7280;
}
.wsp-toolbar__actions { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }

.wsp-btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 38px;
  padding: 0 14px;
  border-radius: 8px;
  border: none;
  background: linear-gradient(135deg, #0e5b46 0%, #16a07a 100%);
  color: #fff;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(22, 160, 122, 0.18);
  transition: transform 0.1s ease, box-shadow 0.15s ease;
}
.wsp-btn-primary:hover { transform: translateY(-1px); box-shadow: 0 6px 14px rgba(22, 160, 122, 0.28); color: #fff; }
.wsp-btn-primary:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }

.wsp-btn-ghost {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 38px;
  padding: 0 14px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #d8dde6;
  color: #1f2a44;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;
}
.wsp-btn-ghost:hover { background: #f3f4fb; }

/* Refresh button — outlined white, rotating SVG icon (per OMS convention) */
.wsp-btn-refresh {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 38px;
  padding: 0 14px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #d8dde6;
  color: #1f2a44;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.wsp-btn-refresh:hover { background: #f3fbf7; border-color: #16a07a; color: #0e5b46; }
.wsp-btn-refresh:disabled { opacity: 0.6; cursor: not-allowed; }
.wsp-btn-refresh__icon {
  transition: transform 0.25s ease;
}
.wsp-btn-refresh:hover .wsp-btn-refresh__icon { transform: rotate(60deg); }
.wsp-btn-refresh.is-loading .wsp-btn-refresh__icon { animation: wspSpin 0.9s linear infinite; }

.wsp-search {
  position: relative;
  flex: 1;
  max-width: 360px;
}
.wsp-search input {
  width: 100%;
  height: 38px;
  padding: 0 12px 0 36px;
  border-radius: 8px;
  border: 1px solid #d8dde6;
  background: #fff;
  font-size: 0.85rem;
  color: #1f2a44;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.wsp-search input:focus {
  outline: none;
  border-color: #16a07a;
  box-shadow: 0 0 0 3px rgba(22, 160, 122, 0.18);
}
.wsp-search__icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
}

.wsp-card {
  background: #fff;
  border: 1px solid #e5e9f2;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.04);
  overflow: hidden;
}
.wsp-card__head {
  background: #fbfcfe;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e9f2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}
.wsp-card__head h2 { margin: 0; font-size: 0.95rem; font-weight: 700; color: #1f2a44; }
.wsp-card__count { font-size: 0.78rem; color: #6b7280; }

.wsp-table { width: 100%; border-collapse: collapse; }
.wsp-table thead th {
  text-align: left;
  font-size: 0.7rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6b7280;
  padding: 10px 16px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e9f2;
  font-weight: 600;
}
.wsp-table tbody td {
  padding: 12px 16px;
  border-bottom: 1px solid #f1f3f8;
  font-size: 0.85rem;
  color: #1f2a44;
  vertical-align: middle;
}
.wsp-table tbody tr:hover { background: rgba(22, 160, 122, 0.04); }
.wsp-table tbody tr:last-child td { border-bottom: none; }
.wsp-actions { text-align: right; white-space: nowrap; }
.wsp-icon-btn {
  background: none; border: none; cursor: pointer;
  width: 30px; height: 30px; border-radius: 8px;
  color: #6b7280; transition: background 0.15s, color 0.15s;
}
.wsp-icon-btn:hover { background: #e6f4ef; color: #0e5b46; }
.wsp-icon-btn--danger:hover { background: #fee2e2; color: #b91c1c; }

.wsp-empty {
  padding: 60px 20px;
  text-align: center;
  color: #6b7280;
  font-size: 0.88rem;
}
.wsp-empty__title { color: #1f2a44; font-weight: 700; margin-bottom: 4px; font-size: 1rem; }

.wsp-loading {
  padding: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #6b7280;
  font-size: 0.85rem;
}

.wsp-thumb {
  width: 42px; height: 42px;
  border-radius: 8px;
  object-fit: cover;
  background: #f3f4f6;
  border: 1px solid #e5e9f2;
}
.wsp-thumb--circle { border-radius: 50%; }

/* Status badges — visually aligned with OMS badge--green/yellow/red/gray */
.wsp-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 600;
}
.wsp-pill--green  { background: #d1fae5; color: #065f46; }
.wsp-pill--yellow { background: #fef3c7; color: #92400e; }
.wsp-pill--amber  { background: #fef3c7; color: #92400e; }
.wsp-pill--red    { background: #fee2e2; color: #991b1b; }
.wsp-pill--gray   { background: #e5e7eb; color: #374151; }
.wsp-pill--blue   { background: #dbeafe; color: #1e40af; }
.wsp-pill--teal   { background: #ccfbf1; color: #115e59; }

/* Modal */
.wsp-modal-backdrop {
  position: fixed; inset: 0; z-index: 2000;
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(3px);
  display: flex; align-items: flex-start; justify-content: center;
  padding: 40px 16px;
  overflow-y: auto;
}
.wsp-modal {
  width: 100%;
  max-width: 640px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.25);
  overflow: hidden;
  animation: wspIn 0.18s ease-out;
}
.wsp-modal--wide  { max-width: 880px; }
.wsp-modal__head {
  display: flex; justify-content: space-between; align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e9f2;
  background: #fbfcfe;
}
.wsp-modal__head h3 { margin: 0; font-size: 1rem; font-weight: 700; color: #1f2a44; }
.wsp-modal__close {
  background: none; border: none; cursor: pointer;
  width: 32px; height: 32px; border-radius: 8px;
  color: #6b7280; font-size: 1.2rem;
}
.wsp-modal__close:hover { background: #e6f4ef; color: #0e5b46; }
.wsp-modal__body { padding: 18px 20px; max-height: 70vh; overflow-y: auto; }
.wsp-modal__foot {
  display: flex; gap: 10px;
  padding: 12px 20px;
  border-top: 1px solid #e5e9f2;
  background: #fbfcfe;
}
.wsp-modal__foot .wsp-btn-primary { flex: 2; justify-content: center; }
.wsp-modal__foot .wsp-btn-ghost   { flex: 1; justify-content: center; }

/* Form */
.wsp-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.wsp-form-grid--single { grid-template-columns: 1fr; }
.wsp-field { display: flex; flex-direction: column; gap: 4px; }
.wsp-field--full { grid-column: 1 / -1; }
.wsp-field label {
  font-size: 0.74rem;
  font-weight: 600;
  color: #374151;
  letter-spacing: 0.02em;
}
.wsp-field input, .wsp-field textarea, .wsp-field select {
  width: 100%;
  border-radius: 8px;
  border: 1px solid #d8dde6;
  padding: 0 12px;
  height: 38px;
  font-size: 0.85rem;
  color: #1f2a44;
  background: #fff;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.wsp-field textarea { min-height: 96px; height: auto; padding: 8px 12px; resize: vertical; }
.wsp-field input:focus, .wsp-field textarea:focus, .wsp-field select:focus {
  outline: none;
  border-color: #16a07a;
  box-shadow: 0 0 0 3px rgba(22, 160, 122, 0.18);
}
.wsp-field__hint { font-size: 0.7rem; color: #9ca3af; }
.wsp-field__error { font-size: 0.72rem; color: #b91c1c; }
.wsp-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.8rem;
  color: #1f2a44;
  cursor: pointer;
  user-select: none;
}
.wsp-toggle input { width: auto; height: auto; }

@keyframes wspIn   { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
@keyframes wspSpin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
</style>
